<template>
  <b-modal size="lg" title="Konfiguracja" v-model="showModal" @hide="cancel">
    <div>
      <b-form>
        <b-form-row
          ><b-col>Ilość wierszy w tabeli</b-col>
          <b-col
            ><b-select
              v-model="tempSettings.itemsPerPage"
              class="w-100 cursor-pointer"
            >
              <option
                v-for="itemsPerPage in itemsPerPageOptions"
                :key="itemsPerPage"
                :value="itemsPerPage"
                class="option-wrap"
              >
                {{ itemsPerPage }}
              </option>
            </b-select></b-col
          >
        </b-form-row>
        <b-form-row
          ><b-col>Zasięg przyklejania do obiektów</b-col>
          <b-col
            ><b-select
              v-model="tempSettings.snapRange"
              class="w-100 cursor-pointer"
            >
              <option
                v-for="snapRange in snapRangeOptions"
                :key="snapRange"
                :value="snapRange"
                class="option-wrap"
              >
                {{ snapRange }}
              </option>
            </b-select></b-col
          >
        </b-form-row>

        <b-form-row
          ><h5 class="mb-2 ml-1">Przyklejanie do warstw</h5>
        </b-form-row>
        <b-form-row
          ><b-table
            :bordered="true"
            :fields="this.snapColumns"
            :items="this.tempSettings.snapLayers"
          >
            <template #cell(snap)="row">
              <div>
                <b-checkbox v-model="row.item.snap" switch></b-checkbox>
              </div> </template></b-table
        ></b-form-row>
        <!-- <b-form-row
          ><b-col>Maksymalna ilość danych z poprzedniej inwentaryzacji</b-col>
          <b-col
            ><b-select
              v-model="tempSettings.maximumInventarizationFeatures"
              class="w-100 cursor-pointer"
            >
              <option
                v-for="maximumInventarizationFeatures in maximumInventarizationFeaturesOptions"
                :key="maximumInventarizationFeatures"
                :value="maximumInventarizationFeatures"
                class="option-wrap"
              >
                {{ maximumInventarizationFeatures }}
              </option>
            </b-select></b-col
          >
        </b-form-row> -->
        <b-form-row
          ><b-col md="8">Surowy widok danych</b-col
          ><b-col md="4">
            <b-checkbox
              v-model.lazy="tempSettings.tableRawData"
              switch
            ></b-checkbox></b-col
        ></b-form-row>
        <b-form-row v-if="tempSettings.multiselectModification"
          ><b-col md="8"
            >Powiadomienie o modyfikacji w ramach selekcji
            wieloatrybutowej</b-col
          ><b-col md="4">
            <b-checkbox
              v-model.lazy="tempSettings.multiselectModification.notification"
              switch
            ></b-checkbox></b-col
        ></b-form-row>
        <b-form-row v-if="tempSettings.multiselectModification"
          ><b-col md="8">Modyfikacja w ramach selekcji wieloatrybutowej</b-col
          ><b-col md="4">
            <b-checkbox
              v-model.lazy="tempSettings.multiselectModification.value"
              switch
            ></b-checkbox></b-col
        ></b-form-row>
      </b-form>
    </div>
    <div slot="modal-footer" class="w-100">
      <b-btn
        class="float-right ml-2"
        variant="primary"
        @click.prevent="saveConfig()"
        >Zapisz</b-btn
      >
      <b-btn
        class="float-right ml-2"
        variant="outline-secondary"
        @click="cancel()"
        >Anuluj</b-btn
      >
      <b-btn
        class="float-right ml-2"
        variant="outline-secondary"
        @click="setDefaultSettings()"
        >Przywróć domyślne</b-btn
      >
    </div></b-modal
  >
</template>

<script>
import { mapGetters } from 'vuex';
import { EDIT_SESSION_RESTORE_DEFAULT_SETTINGS } from '../../store/actions.type';
import {
  WINDOW_NOTIFICATION_SHOW,
  EDIT_SESSION_UPDATE_SETTINGS
} from '../../store/mutations.type';
export default {
  name: 'ManualImportConfigModal',
  components: {},
  props: {
    showManualImportConfigModal: false
  },
  watch: {
    showManualImportConfigModal: function(newVal) {
      this.showModal = newVal;
    },
    showModal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.setStartTempSettings();
        }
      }
    },
    manualImportSettings: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.saveSettingsToLocalStorage();
        }
      }
    }
  },
  data() {
    return {
      tempSettings: {},
      snapRangeOptions: Array.from(Array(51).keys()),
      itemsPerPageOptions: [10, 20, 30],
      maximumInventarizationFeaturesOptions: [
        10000,
        20000,
        30000,
        40000,
        50000
      ],
      snapColumns: [
        { key: 'name', label: 'Warstwa' },
        { key: 'snap', label: 'Przyklejanie' }
      ],
      showModal: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['manualImportSettings', 'layers', 'layersGeometryColumns'])
  },
  mounted() {
    this.readSettingsFromLocalStorage();
  },
  methods: {
    setStartTempSettings() {
      this.tempSettings = JSON.parse(JSON.stringify(this.manualImportSettings));
    },
    cancel() {
      this.setStartTempSettings();
      this.$emit('cancel');
    },
    async setDefaultSettings() {
      await this.$store.dispatch(EDIT_SESSION_RESTORE_DEFAULT_SETTINGS);
      this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces',
        message: 'Domyślne parametry zostały przywrócone.'
      });
      this.cancel();
    },
    async saveConfig() {
      await this.$store.commit(
        EDIT_SESSION_UPDATE_SETTINGS,
        JSON.parse(JSON.stringify(this.tempSettings))
      );
      this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces',
        message: 'Konfiguracja została zapisana'
      });
      this.cancel();
    },
    readSettingsFromLocalStorage() {
      const storedManualImportSettings = localStorage.getItem(
        'manualImportSettings'
      );
      if (storedManualImportSettings) {
        this.$store.commit(
          EDIT_SESSION_UPDATE_SETTINGS,
          JSON.parse(storedManualImportSettings)
        );
      }
    },
    saveSettingsToLocalStorage() {
      localStorage.setItem(
        'manualImportSettings',
        JSON.stringify(this.manualImportSettings)
      );
    }
  }
};
</script>
<style scoped>
.form-row {
  margin-bottom: 0.5rem !important;
}
</style>
